import { IconBase, IconComponent } from './BaseIcon';

export const AlignCenter: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M3 2h26v2H3zM9 8.5h14v2H9zM2 15h28v2H2zM2 28h28v2H2zM6 21.5h20v2H6z" />
  </IconBase>
);
